import React from 'react';
import {Button, Dropdown, Tooltip} from 'antd';
import menuItems, {MenuItem} from './menuItems';
import {useAppSelector} from '../hooks';
import {RootState} from '../store';
import {PlusOutlined} from "@ant-design/icons";

import './HeaderMenus.css';

interface HeaderMenusProps {
    onSelect: (key: string) => void;
    onCreateTask?: () => void;
}

const HeaderMenus: React.FC<HeaderMenusProps> = ({onSelect, onCreateTask}) => {
    const {user} = useAppSelector((state: RootState) => state.user);
    const firm = useAppSelector((state: RootState) => state.user.firm);
    return (
        <div className={"HeaderMenus"}>
            {menuItems.map((item: MenuItem) => {
                if (!user) return null;
                if (item.onlyAdmin && !firm?.isAdmin) return null;

                const visibleChildren = item.children?.filter(
                    (child) => !child.onlyAdmin || firm?.isAdmin
                );
                if (!visibleChildren || visibleChildren.length === 0) return null;

                return (
                    <Dropdown
                        key={item.key}
                        menu={{
                            items: visibleChildren,
                            onClick: (info) => onSelect(info.key),
                        }}
                    >
                        <Button>{item.icon}{item.label}</Button>
                    </Dropdown>
                );
            })}

            {user && (
                <Tooltip title="Nouvelle tâche">
                    <Button
                        type="primary"
                        shape="circle"
                        icon={<PlusOutlined/>}
                        onClick={() => onCreateTask?.()}
                        aria-label="Créer une nouvelle tâche"
                        style={{marginLeft: 8}}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default HeaderMenus;